<div class="row mt-3 mb-5">
	<seira-public-pagination [items]="relatorios" [itemsPerPage]="5">
		<ng-template let-item="item">
			<div class="mb-2">
				<label
					for="tabela-pluviometrico"
					class="text-tertiary mb-2 fw-semibold">
					{{ item.municipio }}
				</label>
				<seira-public-table
					id="tabela-pluviometrico"
					[hasFooter]="false"
					[hasHeader]="false"
					[info]="false"
					[paging]="false"
					[scrollX]="true"
					[searching]="false"
					[columns]="colunas"
					[data]="item.data"></seira-public-table>
			</div>
		</ng-template>
	</seira-public-pagination>
</div>
